export default "__VITE_PUBLIC_ASSET__091a1c4d__"